var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComentari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#6E6259",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410 2401 c-69 -21 -121 -65 -156 -131 -18 -33 -19 -72 -19 -770 0 -734 0 -735 22 -775 25 -47 64 -85 113 -111 34 -18 81 -19 1130 -19 1049 0 1096 1 1130 19 49 26 88 64 113 111 22 40 22 41 22 775 0 734 0 735 -22 775 -25 47 -64 85 -113 111 -33 18 -82 19 -1115 21 -594 1 -1091 -2 -1105 -6z m1604 -566 c-279 -239 -510 -435 -514 -435 -4 0 -235 196 -514 435 l-508 435 1022 0 1022 0 -508 -435z m-1065 -149 c422 -363 528 -449 551 -449 23 0 129 86 551 449 288 247 536 460 551 472 l28 24 0 -695 0 -695 -31 -31 -31 -31 -1068 0 -1068 0 -31 31 -31 31 0 695 0 695 28 -24 c15 -12 263 -225 551 -472z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentari);
export default __webpack_public_path__ + "static/media/comentari.00b3f508.svg";
export { ForwardRef as ReactComponent };